export const weather_api_key = process.env.REACT_APP_WEATHER_API_KEY;
export const ipData_api_key = process.env.REACT_APP_IPDATA_API_KEY;
